import React, { useEffect } from 'react'

import { useHistory } from 'react-router'

import AuthLayouts from '../layouts/AuthLayouts'

import ScrollToTop from '../components/ScrollRestoration'
import { StyledVerify } from './PasswordVerification'

// icons
import danger from '../assets/images/error-destructive.svg'

const InvalidVacancyRequest = () => {
  const history = useHistory()

  useEffect(() => {
    // redirect to home page after 5 seconds
    setTimeout(() => {
      history.push('/')
    }, 5000)
  }, [])

  const handleRedirect = () => {
    history.push('/')
  }

  return (
    <AuthLayouts width="500px">
      <ScrollToTop />
      <StyledVerify>
        <img src={danger} alt="mail" className="icon" />
        <h1>Invalid Vacancy Request Link</h1>
        <p>
          It&apos;s possible that the URL has already been used, is no longer
          active, or was entered incorrectly. To continue, please request a
          valid application link from a HOPLA staff member.
        </p>
        <p>
          If you&apos;re not redirected to the home page in 5 seconds, click
          <span onClick={handleRedirect}> here </span> to go there manually.
        </p>
      </StyledVerify>
    </AuthLayouts>
  )
}

export default InvalidVacancyRequest
